module.exports = __webpack_public_path__ + "static/media/logo.044bf4fc.png";